import { useNavigate } from "react-router-dom";
import Scheduler from "./Scheduler";
import RoleDocumentMapping from "./RoleDocumentMapping";
import RoleWorkflowOrder from "./RoleWorkflowOrder";

const MANAGE_HUB = "/manage";

export function SchedulerPage() {
  const navigate = useNavigate();
  return <Scheduler onBack={() => navigate(MANAGE_HUB)} />;
}

export function RoleDocumentMappingPage() {
  const navigate = useNavigate();
  return <RoleDocumentMapping onBack={() => navigate(MANAGE_HUB)} />;
}

export function RoleWorkflowOrderPage() {
  const navigate = useNavigate();
  return <RoleWorkflowOrder onBack={() => navigate(MANAGE_HUB)} />;
}
